import { Icon } from "@iconify/react";

const RoleModal = ({ show, handleClose, handleSubmit, formData, setFormData, editId, loading }) => {
  if (!show) return null;

  const onCodeChange = (e) => {
    // Server uppercases server-side; reflect that in the input for clarity.
    setFormData({ ...formData, role_code: e.target.value.toUpperCase() });
  };

  return (
    <div className="modal-backdrop-custom" onClick={handleClose}>
      <div
        className="modal-content-custom card radius-16 border-0 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card-header py-16 px-24 border-bottom d-flex align-items-center justify-content-between">
          <h6 className="fw-semibold mb-0">{editId ? "Edit" : "Add New"} Role</h6>
          <button onClick={handleClose} className="btn btn-link p-0 text-secondary-light">
            <Icon icon="mdi:close" className="text-xl" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="card-body p-24">
            <div className="row gy-3">
              <div className="col-12">
                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                  Role Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8 h-48-px"
                  value={formData.role_name}
                  onChange={(e) => setFormData({ ...formData, role_name: e.target.value })}
                  placeholder="e.g., Maintenance Lead"
                  minLength={2}
                  maxLength={50}
                  required
                />
                <small className="text-secondary-light">2–50 characters.</small>
              </div>

              <div className="col-12">
                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                  Role Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8 h-48-px"
                  value={formData.role_code}
                  onChange={onCodeChange}
                  placeholder="e.g., MAINT_LEAD"
                  minLength={2}
                  maxLength={30}
                  required
                />
                <small className="text-secondary-light">
                  2–30 characters. Uppercased automatically. Must be unique within this society.
                </small>
              </div>

              <div className="col-12">
                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                  Description
                </label>
                <textarea
                  className="form-control radius-8"
                  rows={3}
                  value={formData.description || ""}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  placeholder="Optional description of what this role is responsible for"
                  maxLength={255}
                />
              </div>

              {editId && (
                <div className="col-12">
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="role-is-active"
                      checked={!!formData.is_active}
                      onChange={(e) =>
                        setFormData({ ...formData, is_active: e.target.checked })
                      }
                    />
                    <label className="form-check-label text-sm fw-medium" htmlFor="role-is-active">
                      Active
                    </label>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="card-footer py-16 px-24 border-top d-flex justify-content-end gap-2">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-outline-secondary px-20 py-10 radius-8"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn px-20 py-10 radius-8 text-white"
              style={{ backgroundColor: "#f59e0b" }}
              disabled={loading}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                <Icon icon={editId ? "mdi:check" : "mdi:plus"} className="text-lg me-1" />
              )}
              {editId ? "Update" : "Add"} Role
            </button>
          </div>
        </form>
      </div>

      <style>{`
        .modal-backdrop-custom {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
          animation: fadeIn 0.2s ease;
        }
        .modal-content-custom {
          width: 100%;
          max-width: 520px;
          margin: 16px;
          animation: slideUp 0.3s ease;
        }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .h-48-px { height: 48px; }
      `}</style>
    </div>
  );
};

export default RoleModal;
